import {CircularProgress} from '@mui/material'
import "./loaders.css";

export default function LoaderComponent() {
    return (
        <div className={"loader-container"}>
            <CircularProgress/>
        </div>
    )
}